import React from 'react';

const GroupInfoModal = ({ isOpen, group, onClose, onLeaveGroup, currentUser }) => {
    if (!isOpen || !group) return null;

    return (
        <div className={`modal ${isOpen ? 'active' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3><i className="fas fa-users" style={{ color: 'var(--group-primary)' }}></i> Информация о группе</h3>
                    <button className="btn-icon" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <h4><i className="fas fa-users" style={{ color: 'var(--group-primary)' }}></i> {group.name}</h4>
                <p><i className="fas fa-user-friends"></i> Участников: {group.members.length}</p>
                <div className="members-list">
                    <strong><i className="fas fa-list"></i> Список участников:</strong>
                    {group.members.map((member, idx) => (
                        <div key={idx} className="member-item">
                            <span><i className="fas fa-user"></i> {member}</span>
                            {member === currentUser && (
                                <span className="group-badge"><i className="fas fa-crown"></i> Вы</span>
                            )}
                        </div>
                    ))}
                </div>
                <button 
                    className="btn-outline btn-sm" 
                    onClick={onLeaveGroup}
                    style={{ marginTop: '1rem', width: '100%', borderColor: 'var(--group-primary)', color: 'var(--group-primary)' }}
                >
                    <i className="fas fa-sign-out-alt"></i> Покинуть группу
                </button>
            </div>
        </div>
    );
};

export default GroupInfoModal;
